/**
 * Stay22 places-to-stay map embed URL helpers.
 * Used by SEO discovery venue pages and listing Location sections.
 */

const cleanParam = value => String(value || '').trim();

export const stay22ConfigFromEnv = () => {
  const enabled =
    process.env.REACT_APP_STAY22_ENABLED === 'true' ||
    process.env.SEO_DISCOVERY_STAY22_ENABLED === 'true';
  const aid =
    cleanParam(process.env.REACT_APP_STAY22_AID) ||
    cleanParam(process.env.SEO_DISCOVERY_STAY22_AID) ||
    '';
  const campaign =
    cleanParam(process.env.REACT_APP_STAY22_CAMPAIGN) ||
    cleanParam(process.env.SEO_DISCOVERY_STAY22_CAMPAIGN) ||
    'promotix';
  const mainColor =
    cleanParam(process.env.REACT_APP_STAY22_MAIN_COLOR) ||
    cleanParam(process.env.SEO_DISCOVERY_STAY22_MAIN_COLOR) ||
    'ff822f';
  return { enabled, aid, campaign, mainColor };
};

/**
 * @param {object} opts
 * @param {string} [opts.aid]
 * @param {number|string} [opts.lat]
 * @param {number|string} [opts.lng]
 * @param {string} [opts.address]
 * @param {string} [opts.venueName]
 * @param {string} [opts.mainColor]
 * @param {string|string[]} [opts.campaign]
 * @returns {string|null}
 */
export const buildStay22EmbedUrl = ({
  aid,
  lat,
  lng,
  address,
  venueName,
  mainColor = 'ff822f',
  campaign = 'promotix',
} = {}) => {
  const cleanAid = cleanParam(aid);
  if (!cleanAid) {
    return null;
  }

  const params = new URLSearchParams();
  params.set('aid', cleanAid);

  const hasCoords =
    lat != null &&
    lng != null &&
    Number.isFinite(Number(lat)) &&
    Number.isFinite(Number(lng));

  if (hasCoords) {
    params.set('lat', String(lat));
    params.set('lng', String(lng));
  } else {
    const addr = cleanParam(address) || cleanParam(venueName);
    if (!addr) {
      return null;
    }
    params.set('address', addr);
  }

  if (cleanParam(venueName)) {
    params.set('venue', cleanParam(venueName));
  }
  params.set('maincolor', cleanParam(mainColor) || 'ff822f');

  const campaigns = Array.isArray(campaign) ? campaign : [campaign];
  campaigns
    .map(c => cleanParam(c))
    .filter(Boolean)
    .forEach(c => params.append('campaign', c));

  return `https://www.stay22.com/embed/gm?${params.toString()}`;
};
